export enum Prefix {
  color = 'color',
  fontSize = 'font-size',
  fontWeight = 'font-weight',
  fontFamily = 'font-family',
  lineHeight = 'line-height',
  zIndex = 'level',
  borderRadius = 'border-radius',
  unit = 'unit',
  spacing = 'spacing',
}
